import { Settings } from '@salesforce/design-system-react';

// react-modal's `setAppElement` (via `Settings.setAppElement`) throws
// synchronously when the selector matches no element in the DOM:
//   "react-modal: No elements were found for selector #main-wrapper."
//
// Our modal component modules set the app element at import time, and the
// `components` Vite pack eagerly evaluates every component module on every page
// it loads on — including pages whose layout has no `#main-wrapper` (e.g.
// `mfe_layout`, used by /salesforce-military). There the unconditional call
// surfaces as an uncaught console error and aborts the eager glob.
//
// Guarding on presence keeps the exact behaviour when `#main-wrapper` exists and
// turns a missing app element into a no-op instead of a throw. react-modal
// simply leaves the app element unset on those pages, which is its documented
// fallback.
export default function setModalAppElement(selector = '#main-wrapper') {
  if (document.querySelector(selector)) {
    Settings.setAppElement(selector);
  }
}
